import { Div } from '@gaiads/telia-react-component-library';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { PageHeader as ReusableHeader } from '@cdaas/reusable-components-daas';
import { useTranslation } from 'react-i18next';

import { selectOrganization } from '../../store/order';
import { routes } from './routes';

export const PageHeader = () => {
  const organization = useSelector(selectOrganization);
  const history = useHistory();
  const { t } = useTranslation('sideNavigation');

  // This Header will be replaced totally with Teros generic reusable header component in future tasks
  const getRightHeaderText = (pathname: string) => {
    if (pathname.endsWith(routes.companyInformation)) {
      return t('companyInformation');
    } else if (pathname.endsWith(routes.users)) {
      return t('users');
    } else if (pathname.endsWith(routes.userGroups)) {
      return t('userGroups');
    } else if (pathname.endsWith(routes.orders)) {
      return t('orders');
    } else if (pathname.endsWith(routes.devices)) {
      return t('devices');
    }
  };

  return (
    <Div padding={{ top: 'lg', bottom: 'lg' }} data-testid={'pageheader'}>
      <ReusableHeader subheaderText={organization?.name || ''}>{getRightHeaderText(history?.location?.pathname || '')}</ReusableHeader>
    </Div>
  );
};
